import { axios } from '@/api/common'
import { queryOptions } from '@tanstack/react-query'
import { Sale2310GetResultModel, Sale2310GetResultSchema } from './get.schema'

export async function fetchSale2310(
  id: number
): Promise<Sale2310GetResultModel> {
  const response = await axios.get<Sale2310GetResultModel>(
    `/api/sale/sale2310/${id}`
  )
  return Sale2310GetResultSchema.parse(response.data)
}

export const getSale2310ByIdOptions = (id: number) =>
  queryOptions({
    queryKey: ['sale2310', id],
    queryFn: () => fetchSale2310(id),
  })
